import { API_INSTANCE, fullBuildURL } from 'src/features/utils';
import * as T from './types';

export const searchAttendeesStatsByEventApi = async (payload: T.AttendeeStatsPayload) => {
  const criteriaQueryParams = new URLSearchParams(payload.criteria).toString();
  return await API_INSTANCE.get<T.AttendeeStatsResponse>(
    fullBuildURL(
      `/api/v1/dashboard/attendees/events/${payload.eventId}/stats`,
      `&limit=${payload.limit}&offset=${payload.offset}&${criteriaQueryParams}`,
    ),
  );
};
